import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgRsProfilePlaceholderXl = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M40 0c22.091 0 40 17.908 40 40a39.8 39.8 0 0 1-4.293 18.048A11.94 11.94 0 0 0 69 56c-6.627 0-12 5.372-12 12 0 2.635.85 5.07 2.288 7.05A39.8 39.8 0 0 1 40 80C17.909 80 0 62.091 0 40S17.909 0 40 0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M42.412 16.754c7.049 0 12.762 5.714 12.762 12.761v7.142a12.7 12.7 0 0 1-4.098 9.358c-2.462 2.277-2.366 6.2.24 8.31a10.4 10.4 0 0 0 3.009 1.697c2.126.772 4.532 1.727 6.898 2.84A11.97 11.97 0 0 0 57 68c0 1.372.23 2.69.655 3.919A35.8 35.8 0 0 1 41 76c-10.72 0-20.34-4.69-26.935-12.124a.884.884 0 0 1 .145-1.3c3.926-2.769 9.247-5.023 13.465-6.554a10.4 10.4 0 0 0 3.009-1.698c2.606-2.109 2.703-6.032.24-8.308a12.7 12.7 0 0 1-4.098-9.359v-7.142c0-7.047 5.714-12.76 12.762-12.76z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.06,
        fillRule: "nonzero",
        d: "M40 0c21.87 0 39.64 17.552 39.994 39.338L80 40l-.006.661a39.8 39.8 0 0 1-4.288 17.387 12 12 0 0 0-.854-.527 38.8 38.8 0 0 0 4.143-16.876L79 40l-.005-.645C78.65 18.113 61.323 1 40 1 18.46 1 1 18.46 1 40s17.46 39 39 39a38.83 38.83 0 0 0 18.733-4.785q.261.43.556.835A39.8 39.8 0 0 1 39.999 80C17.91 80 0 62.092 0 40S17.91 0 40 0"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgRsProfilePlaceholderXl$1 = SvgRsProfilePlaceholderXl;

export { SvgRsProfilePlaceholderXl$1 as default };
